<template>
	<div>
		<FormGroup>
			<RadioGroup
				v-model="yesNo"
				:options="yesNoOptions"
				@change="emitChangeEvent"
			/>
		</FormGroup>
		<div v-if="extraDataEligible" class="sections mt-4">
			<section>
				<h3>In welchem Umfang würdest du reisen?</h3>
				<SelectInline
					v-model="scope"
					:characteristic-items="meta.travelWillingness"
					single-choice
					label-type="application"
					@input="emitChangeEvent"
				/>
			</section>
			<section>
				<h3>Würdest du auch beruflich extern übernachten?</h3>
				<RadioGroup
					v-model="externalSleepoverYesNo"
					:options="yesNoOptions"
					@change="emitChangeEvent"
				/>
				<div
					v-if="externalSleepoverYesNo"
					class="mt-4 pl-4"
				>
					<h3>Wie viele Übernachtungen wären in Ordnung?</h3>
					<SelectInline
						v-model="externalSleepoverScope"
						:characteristic-items="meta.externalSleepover"
						single-choice
						label-type="application"
						@input="emitChangeEvent"
					/>
				</div>
			</section>
		</div>
	</div>
</template>
<script>
import FormGroup from "@/vue/common/form/Group";
import RadioGroup from "@/vue/common/form/RadioGroup";
import SelectInline from "@/vue/characteristic/SelectInline";
import {isDefined} from "@/helper/Value";
import {arrayIsNotEmpty} from "@/helper/Array";

export default {

	components: {
		SelectInline,
		RadioGroup,
		FormGroup,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		meta: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			display: this.initialDisplay,
			yesNo: this.value?.yesNo,
			yesNoOptions: Object.freeze([
				{value: null, text: 'Egal'},
				{value: true, text: 'Ja'},
				{value: false, text: 'Nein'},
			]),
			scope: isDefined(this.value?.scope)
				? [ { item: this.value.scope } ]
				: undefined,
			externalSleepoverYesNo: this.value?.externalSleepoverYesNo ?? null,
			externalSleepoverScope: isDefined(this.value?.externalSleepoverScope)
				? [ { item: this.value.externalSleepoverScope } ]
				: undefined,
		};
	},

	computed: {
		yesNoValid ()
		{
			return this.yesNo !== undefined;
		},
		extraDataEligible ()
		{
			return this.yesNo === true;
		},
		scopeValid ()
		{
			return !this.extraDataEligible || this.scope !== undefined;
		},
		externalSleepoverValid ()
		{
			if (!this.extraDataEligible)
			{
				return true;
			}

			if (this.externalSleepoverYesNo === undefined)
			{
				return false;
			}

			return this.externalSleepoverYesNo
				? (isDefined(this.externalSleepoverScope) && arrayIsNotEmpty(this.externalSleepoverScope))
				: true;
		},
		dataValid ()
		{
			return this.yesNoValid
				&& this.scopeValid
				&& this.externalSleepoverValid;
		}
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				yesNo: this.yesNo,
				scope: this.extraDataEligible
					? _.first(this.scope).item
					: undefined,
				externalSleepoverYesNo: this.extraDataEligible
					? this.externalSleepoverYesNo
					: undefined,
				externalSleepoverScope: this.externalSleepoverYesNo === true
					? _.first(this.externalSleepoverScope).item
					: undefined,
			});
		}
	}
}
</script>
